var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2531 10.9427H24.1788C23.9766 10.2905 23.6164 9.6742 23.0982 9.15485C22.5896 8.64626 21.9769 8.27769 21.3104 8.07186V5H19.1265V7.97613C18.3558 8.14366 17.651 8.5254 17.0825 9.09382L15.6274 10.549C15.2014 10.975 15.2014 11.6667 15.6274 12.0939C16.0534 12.5199 16.7451 12.5199 17.1723 12.0939L18.6274 10.6387C19.0056 10.2606 19.5166 10.0571 20.0634 10.0631C20.6223 10.0703 21.1512 10.2965 21.5545 10.6998C22.3778 11.5231 22.4053 12.837 21.6155 13.6268L18.5556 16.6867C17.7658 17.4765 16.4519 17.449 15.6286 16.6257C15.2026 16.1997 14.5109 16.1997 14.0837 16.6257C13.6577 17.0517 13.6577 17.7434 14.0837 18.1706C14.9321 19.019 16.0438 19.445 17.1484 19.445C18.223 19.445 19.2904 19.0418 20.1005 18.2316L23.1604 15.1717C23.7408 14.5913 24.1106 13.8793 24.2757 13.1278H27.2554V10.9427H27.2531Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8664 20.376L13.4112 21.8312C12.6214 22.621 11.3087 22.5935 10.4842 21.7702C9.66087 20.9469 9.63334 19.6329 10.4231 18.8431L13.483 15.7832C14.2728 14.9934 15.5868 15.0209 16.4101 15.8442C16.8361 16.2703 17.5278 16.2703 17.955 15.8442C18.381 15.4182 18.381 14.7265 17.955 14.2993C16.2797 12.624 13.5812 12.5965 11.9393 14.2383L8.87944 17.2982C8.29905 17.8786 7.92928 18.5906 7.76414 19.3421H4.78442V21.526H7.85868C8.06091 22.1782 8.42111 22.7945 8.93927 23.3139C9.45743 23.832 10.0737 24.1922 10.7271 24.3945V27.4699H12.911V24.4902C13.6637 24.3263 14.3758 23.9553 14.9549 23.3749L16.4101 21.9197C16.8361 21.4937 16.8361 20.8021 16.4101 20.3748C15.9841 19.9488 15.2924 19.9488 14.8664 20.376Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrax);
export default __webpack_public_path__ + "static/media/frax.95601ab4dd8b7833259001e1fead45e4.svg";
export { ForwardRef as ReactComponent };